import React, { useState, useEffect } from "react"
import createPersistedState from "use-persisted-state"

import { withMicrocopy } from "~contexts/MicrocopyContext"

import Explorer from "~components/Explorer"
import Endpoint, { style } from "./Endpoint"

const usePersistedState = createPersistedState("com.box.developer.credentials")

const Component = ({ endpoint, microcopy }) => {
  const [credentials, setCredentials] = usePersistedState({})
  const explorer = new Explorer({
    endpoint,
    useState,
    microcopy,
    credentials,
    setCredentials,
  })

  useEffect(() => {
    explorer.validate()
  }, [])

  return (
    <Endpoint microcopy={microcopy} explorer={explorer} endpoint={endpoint} />
  )
}

export default withMicrocopy(Component)
export { default as Navigation } from "./Navigation"
export { style }
